























































































































































































































































































































































































































































































































































































































































































































































































// @ is an alias to /src
import { Component, Emit, Vue } from "vue-property-decorator";
import Formulario from "@/components/Formulario.vue";
import Navbar from "@/components/Navbar.vue";

@Component({
  components: {
    Navbar,
    Formulario,
  },
})
export default class Ertiga extends Vue {
  @Emit()
  openModalDetalle(
    auto: string,
    titulo: string,
    interes: string,
    version: string
  ) {
    return {
      auto: auto,
      titulo: titulo,
      interes: interes,
      version: version,
    };
  }

  public showModal(): void {
    this.$modal.show(
      "contactModal",
      {},
      {
        height: "auto",
        scrollable: true,
      }
    );
  }

  expand: boolean = true;
  toggleExpand() {
    this.expand = !this.expand;
  }
}
